import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSummary: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"summary, summarize"} maskId="square-filled-radius-0-stroke-1-IconSummary"><path fillRule="evenodd" clipRule="evenodd" d="M4 5V17H18V15L21.3333 17.5L18 20V18H3V5H4ZM7 7H17V8H7V7ZM7 12H14V13H7V12Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconSummary;
